import React from "react";
import PropTypes from "prop-types";

const TouEnabled = (props) => {
  const { className, style } = props;
  return (
    <svg
      className={className}
      style={style}
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="5" y="5" width="11" height="2" rx="1" fill="#4871F0" />
      <rect x="5" y="9" width="11" height="2" rx="1" fill="#4871F0" />
      <rect x="5" y="13" width="6" height="2" rx="1" fill="#4871F0" />
      <rect
        x="1"
        y="1"
        width="19"
        height="19"
        rx="2"
        stroke="#4871F0"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

TouEnabled.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
};

TouEnabled.defaultProps = {
  className: undefined,
  style: undefined,
};

export default TouEnabled;
